/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ReportQueueFromJSON(json) {
    return ReportQueueFromJSONTyped(json, false);
}
export function ReportQueueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'queueId': !exists(json, 'queueId') ? undefined : json['queueId'],
        'scheduleId': !exists(json, 'scheduleId') ? undefined : json['scheduleId'],
        'reportId': !exists(json, 'reportId') ? undefined : json['reportId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'reportName': !exists(json, 'reportName') ? undefined : json['reportName'],
        'foundSetIds': !exists(json, 'foundSetIds') ? undefined : json['foundSetIds'],
        'findFilters': !exists(json, 'findFilters') ? undefined : json['findFilters'],
        'outputFileName': !exists(json, 'outputFileName') ? undefined : json['outputFileName'],
        'outputType': !exists(json, 'outputType') ? undefined : json['outputType'],
        'sortField': !exists(json, 'sortField') ? undefined : json['sortField'],
        'needsRunFlag': !exists(json, 'needsRunFlag') ? undefined : json['needsRunFlag'],
        'displayReportFlag': !exists(json, 'displayReportFlag') ? undefined : json['displayReportFlag'],
        'runResult': !exists(json, 'runResult') ? undefined : json['runResult'],
        'reportSource': !exists(json, 'reportSource') ? undefined : json['reportSource'],
        'runDateTime': !exists(json, 'runDateTime') ? undefined : (json['runDateTime'] === null ? null : new Date(json['runDateTime'])),
    };
}
export function ReportQueueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'queueId': value.queueId,
        'scheduleId': value.scheduleId,
        'reportId': value.reportId,
        'propertyId': value.propertyId,
        'userId': value.userId,
        'reportName': value.reportName,
        'foundSetIds': value.foundSetIds,
        'findFilters': value.findFilters,
        'outputFileName': value.outputFileName,
        'outputType': value.outputType,
        'sortField': value.sortField,
        'needsRunFlag': value.needsRunFlag,
        'displayReportFlag': value.displayReportFlag,
        'runResult': value.runResult,
        'reportSource': value.reportSource,
        'runDateTime': value.runDateTime === undefined ? undefined : (value.runDateTime === null ? null : value.runDateTime.toISOString()),
    };
}
